var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButterfly5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 172,
    viewBox: "0 0 160 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_345_12961",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 172
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6995 90.5263L12.4352 81.4737L0 0L35.6477 30.4498L64.6632 74.5999L129.326 47.7321L160 43.6172L111.088 112.746L104.456 114.392V123.445L69.6373 172L55.544 128.383L55.7499 123.445L29.8446 167.885L18.2383 98.756L25.6995 90.5263Z",
    fill: "#D9E084"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_345_12961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6995 90.5263L12.4352 81.4737L0 0L35.6477 30.4498L64.6632 74.5999L129.326 47.7321L160 43.6172L111.088 112.746L104.456 114.392V123.445L69.6373 172L55.544 128.383L55.7499 123.445L29.8446 167.885L18.2383 98.756L25.6995 90.5263Z",
    fill: "#D9E084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6995 90.5263L12.4352 81.4737L64.6632 74.5999L111.088 112.746L104.456 114.392V123.445L69.6373 172L55.544 128.383L55.7499 123.445L29.8446 167.885L18.2383 98.756L55.7499 123.445L97.8238 116.038L64.6632 74.5999L25.6995 90.5263Z",
    fill: "#AADBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6632 74.5999L97.8238 116.038L104.456 114.392V117L94 119.5L64.6632 74.5999L57 133L55.5 128.5L55.7499 123.445L64.6632 74.5999L18.2383 98.756L25.6995 90.5263L64.6632 74.5999Z",
    fill: "#48A7A1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButterfly5);
export default __webpack_public_path__ + "static/media/butterfly-5.2f58062a193e3a5a66f0f742557ae701.svg";
export { ForwardRef as ReactComponent };